var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/anonymous/Desktop/components/SubMenuItem.js",
  _this = this;
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@wds/box';
import { List } from '@wds/list';
import { Typography } from '@wds/typography';
import SMHeaderContext from '../../../SMHeaderContext';
export var SubMenuItem = function SubMenuItem(_ref) {
  var subTitle = _ref.subTitle,
    title = _ref.title,
    url = _ref.url,
    openInNewWindow = _ref.openInNewWindow,
    name = _ref.name;
  var _useContext = useContext(SMHeaderContext),
    excludeMenuItems = _useContext.excludeMenuItems;
  if (excludeMenuItems.includes(name)) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "sm-nav-submenu__list-item",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(List.Item, Object.assign({
    key: title,
    isNavigable: true,
    transparent: true,
    interactive: true,
    navigationTarget: url
  }, openInNewWindow === true && {
    target: '_blank',
    rel: 'noopener noreferrer'
  }, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Box, {
    py: 4,
    mt: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body",
    weight: "medium",
    color: "link",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 11
    }
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "sm-nav-submenu__product-subtitle",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 11
    }
  }, subTitle))));
};
export default SubMenuItem;
SubMenuItem.propTypes = {
  subTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  openInNewWindow: PropTypes.bool,
  name: PropTypes.string.isRequired
};
SubMenuItem.defaultProps = {
  openInNewWindow: false
};
//# sourceMappingURL=SubMenuItem.js.map